import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=040969aa&scoped=true&lang=html&"
import script from "./AccountManagement.vue?vue&type=script&lang=ts&"
export * from "./AccountManagement.vue?vue&type=script&lang=ts&"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=040969aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040969aa",
  null
  
)

export default component.exports